// Generates an URL for the generic proxy. Inputs
// - base_uri is of this form:
//   - "https://orthophoto-viewer-backend.herokuapp.com/proxy/{s3_bucket}/{s3_key}", or
//   - "s3://{s3_bucket}/{s3_key}"
// - prefix_type: of the following values:
//   - "parent_folder": an access to the parent folder will be required
//   - "file": a simple access to the file will be required
// - token: a user token
// - metadata: {"layerId": "...", "photoId": "..."}
export function make_generic_proxy_url(base_uri, prefix_type, token, metadata={}){
  // 1. Retrieve bucket and key
  let s3_bucket = null;
  let s3_key = null;
  const match_old_proxy = base_uri.match(/^https\:\/\/orthophoto-viewer-backend\.herokuapp\.com\/proxy\/([^\/]+)\/(.+)$/);
  const match_s3_uri = base_uri.match(/^s3\:\/\/([^\/]+)\/(.+)$/);
  if (match_old_proxy){
    s3_bucket = match_old_proxy[1];
    s3_key = match_old_proxy[2];
  }
  else if (match_s3_uri){
    s3_bucket = match_s3_uri[1];
    s3_key = match_s3_uri[2];
  }
  else {
    throw new Error("Can't parse base_uri: " + base_uri)
  }

  // 2. Make generic proxy URL
  let proxy_url = "https://cornis-proxy-service.cornis.fr/get_content/ivone/" + s3_bucket + "/" + s3_key;
  proxy_url += `?token=${token}`;
  proxy_url += `&metadata=${encodeURIComponent(JSON.stringify(metadata))}`;
  if (prefix_type === "parent_folder"){
    proxy_url += `&authorizer_prefix=` + encodeURIComponent(s3_key.split("/").slice(0, -1).join("/") + "/");
  }
  else if (prefix_type === "file"){
    // Nothing to do
  }
  else {
    throw new Error("Unknown prefix_type: " + prefix_type)
  }
  return proxy_url;
}
